

export function showFeebackDialog(url){
    //窗口大小位置定义开始
    var _height=600;//建议弹出框高度
    var _width=800;//建议弹出框宽度
    var i = window.screenLeft != undefined ? window.screenLeft: screen.left;
    var r = window.screenTop != undefined ? window.screenTop: screen.top;
    var width = window.innerWidth ? window.innerWidth: document.documentElement.clientWidth ? document.documentElement.clientWidth: screen.width;
    var height = window.innerHeight ? window.innerHeight: document.documentElement.clientHeight ? document.documentElement.clientHeight: screen.height;
    var c = Math.abs(width / 2 - _width / 2) + i;
    var l = Math.abs(height / 2 - _height / 2) + r;
    var openWay="_blank";//弹出窗口
    //窗口大小位置定义结束
    var s = window.open(url,openWay, "toolbar=no, menubar=no, titlebar=no, scrollbars=yes, location=no, status=no, width=" + _width + ", height=" + _height + ", top=" + l + ", left=" + c);    
    if (window.focus) {
      s.focus()
    }       
};

export function checkMobile() {
  const mobileAgents = ["Android", "iPhone", "SymbianOS", "Windows Phone", "iPad", "iPod"];
  return mobileAgents.some((agent) => navigator.userAgent.includes(agent));
}
